import React, { memo, useMemo } from 'react';

import menuItemIcons from 'pages/company/WorkspaceRoute/components/DocumentContextMenu/components/MenuItemIcons';
import ListItemIcon from '@mui/material/ListItemIcon';
import { useTheme } from '@mui/material';

const MenuItemIcon = ({ id, color }) => {
  const { direction } = useTheme();
  const isRtl = direction === 'rtl';

  const Icon = useMemo(() => menuItemIcons(isRtl)?.[id], [id, isRtl]);

  return Icon ? (
    <ListItemIcon sx={{ minWidth: 32, color }}>
      <Icon />
    </ListItemIcon>
  ) : null;
};

export default memo(MenuItemIcon);
